import { languageChangeEvent, getString, keyExists } from '@nackle/intl-tools';
import { useEffect, useCallback, useMemo, useState } from 'react';
import { DEFAULT_LOCALE_CODE } from '../const';

export const useTranslations = () => {
    const [ activeLocale, setActiveLocale ] = useState( DEFAULT_LOCALE_CODE );
    const [ isLoading, setLoading ] = useState( false );

    /**
     * When intl-tools gets updates with a new language, store the new locale
     * code and trigger a rerender. This allows for components that are using
     * direct strings from intl-tools to rerender when the language is updated
     * (the alternative is using a `<Translate />` component that will rerender
     * automatically when the language is changed).
     */
    const handleLanguageUpdate = useCallback( ( { localeCode, bundle } ) => {
        setActiveLocale( localeCode );
    }, [ setActiveLocale ] );

    /**
     * Register callbacks to intl-tools to be able to respond to successful
     * language updates.
     */
    useEffect( () => {
        // TODO: Attempt to get the locale code currently loaded into intl-tools.
        // ...

        // Register callbacks to language change events inside of intl-tools.
        languageChangeEvent.on( handleLanguageUpdate );
        return () => {
            languageChangeEvent.off( handleLanguageUpdate );
        };
    }, [ handleLanguageUpdate ] );

    /**
     * Triggers the update of the site to display content in a new language
     * specified by locale code.
     * 
     * @param localeCode - The locale code for the desired language.
     */
    const setLanguage = useCallback( async ( localeCode ) => {
        setLoading( true );

        // ...

        setLoading( false );
    }, [ setLoading ] );

    return useMemo( () => {
        return {
            getString,
            keyExists,
            locale: activeLocale,
            setLanguage,
            loading: isLoading,
        };
    }, [ activeLocale, setLanguage, isLoading ] );
};
